import { render, staticRenderFns } from "./UserPrivacy.vue?vue&type=template&id=7b296401&scoped=true&"
import script from "./UserPrivacy.vue?vue&type=script&lang=js&"
export * from "./UserPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b296401",
  null
  
)

export default component.exports